import React, { useState } from "react"

import SlideStandard from "./components/SlideStandard"
import SlideVariant from "./components/SlideVariant"

const SlideBoxContainer = ({ component, grid }) => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0)
  const bgClass = component?.background?.replace(/ /g, "").toLowerCase()
  const cardVariants = {
    enter: {
      opacity: 0,
      filter: "blur(3px)",
    },
    center: {
      opacity: 1,
      filter: "blur(0)",
    },
    exit: {
      opacity: 0,
      filter: "blur(3px)",
    },
  }

  const handleSwitcher = (index) => {
    setActiveSlideIndex(index)
  }

  switch (component?.style) {
    case "Variant":
      return (
        <SlideVariant
          component={component}
          grid={grid}
          bgClass={bgClass}
          cardVariants={cardVariants}
          handleSwitcher={handleSwitcher}
          activeSlideIndex={activeSlideIndex}
        />
      )
    default:
      return (
        <SlideStandard
          component={component}
          grid={grid}
          bgClass={bgClass}
          cardVariants={cardVariants}
          handleSwitcher={handleSwitcher}
          activeSlideIndex={activeSlideIndex}
        />
      )
  }
}

export default SlideBoxContainer
